const WS_CHAT_URL = process.env.REACT_APP_WS_CHAT_URL || "ws://localhost:9078";
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8088";
const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY || "BOkrVZicNCi3_juj6CdE2zUijO24f16JJu1XH2BJRts_R0j6AfsAPIaPUakJGoZ-QTKgDaAqbXzXGCt53b7d6rw";
const DISABLE_CLEAR_BUTTON = process.env.REACT_APP_DISABLE_CLEAR_BUTTON === "true";
export { API_URL, DISABLE_CLEAR_BUTTON, VAPID_PUBLIC_KEY, WS_CHAT_URL };
